import { useTranslation } from "react-i18next";
import * as z from "zod";

export const useAddressSchema = (
  municipalityFieldName: string,
  settlementFieldName: string,
  streetFieldName: string,
  Field: string,
  apartmentFieldName: string,
) => {
  const { t } = useTranslation();

  return z.object({
    [municipalityFieldName]: z
      .number({
        required_error: t(
          "formAddressInput.fields.municipality.errors.required",
        ),
      })
      .gt(0, t("formAddressInput.fields.municipality.errors.required")),
    [settlementFieldName]: z
      .number({
        required_error: t("formAddressInput.fields.settlement.errors.required"),
      })
      .gt(0, t("formAddressInput.fields.settlement.errors.required")),
    [streetFieldName]: z
      .number({
        required_error: t("formAddressInput.fields.street.errors.required"),
      })
      .gt(0, t("formAddressInput.fields.street.errors.required")),
    [Field]: z
      .string({
        required_error: t("formAddressInput.fields.house.errors.required"),
      })
      .min(1, t("formAddressInput.fields.house.errors.required")),
    [apartmentFieldName]: z.optional(z.string()),
  });
};
